import React, { useState, useEffect, useContext } from 'react';
import { Link } from "react-router-dom";
import BootstrapTable from 'react-bootstrap-table-next';
import { createMuiTheme, Slide, Container, Dialog, Toolbar, Typography, CssBaseline, Backdrop, CircularProgress, Grid, AppBar } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import { ThemeProvider } from '@material-ui/styles';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import EditIcon from '@material-ui/icons/Edit';
import styles from "../../../jss/material-dashboard-react/views/dashboardStyle.js";
import { GlobalTheme } from '../../../layouts/theme';
import { Theme } from '../../contexts/themeContext';
import { Context } from "../../contexts/siteContext";
import { HttpService } from "../../../apiAuthorization/httpService";
import Card from "../../card/card.js";
import CardBody from "../../card/cardBody.js";
import SystemVariableAdd from "../systemVariable/systemVariableAdd";
import SmallMenu from '../../header/smallMenu';
import StatusIcon from '../../common/statusIcon';

const useStyles = makeStyles(styles);
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function SystemVariableList(props) {
    const classes = useStyles();
    const { defaultSite } = useContext(Context);
    const { theme } = useContext(Theme);
    const [systemVariables, setSystemVariables] = useState([]);
    const [recordToBeEdit, setRecordToBeEdit] = useState([]);
    const [variableEditOpen, setVariableEditOpen] = useState(false);
    const [backDrop, setBackDrop] = useState(true);
    const currentTheme = theme ? createMuiTheme(GlobalTheme[theme]) : createMuiTheme(GlobalTheme[localStorage.getItem("theme")]);

    const rowStyle = (row, rowIndex) => {
        return { backgroundColor: rowIndex % 2 === 0 ? '' : currentTheme.alternateGridRow };
    };

    const closeVariableEdit = () => {
        setVariableEditOpen(false);
    };

    const editSystemVariable = (row) => {
        setRecordToBeEdit(row);
        setVariableEditOpen(true);
    };

    const updateList = (item) => {
        if (item !== null) {
            const data = systemVariables;
            const index = data.findIndex(d => d.SystemVariableId === item.SystemVariableId);
            if (index !== -1)
                data[index] = item;
            setSystemVariables(data);
        }
    };

    const getSystemVariables = () => {
        HttpService.post('/SystemVariable/GetSystemVariables', {
            SiteId: defaultSite.id
        })
            .then((result) => {
                setSystemVariables(result.data);
                setBackDrop(false);
            },
                (error) => {
                    console.log(error);
                });
    };

    useEffect(() => {
        getSystemVariables();
        // eslint-disable-next-line
    }, []);

    const fetchData = () => {
        const columns = [
            {
                dataField: 'SystemVariableId',
                text: 'ID',
                hidden: true
            },
            {
                dataField: "rowNumber",
                text: '#',
                formatter: (cellContent, row, index) => { return (<div>{index + 1}</div>); },
                style: (cell, row, rowIndex, colIndex) => {
                    return {
                        color: currentTheme.text
                    };
                },
                headerStyle: {
                    color: currentTheme.headerColor,
                    background: currentTheme.headerBackground,
                    width: '35px'
                }
            },
            {
                dataField: 'VariableName',
                text: 'Name',
                sort: true,
                validator: (newValue, row, column) => {
                    if (newValue === "") {
                        return {
                            valid: false,
                            message: 'Name is required.'
                        };
                    }
                    return true;
                },
                style: (cell, row, rowIndex, colIndex) => {
                    return {
                        color: currentTheme.text
                    };
                },
                headerStyle: {
                    color: currentTheme.headerColor,
                    background: currentTheme.headerBackground
                }
            },
            {
                dataField: 'VariableValue',
                text: 'Value',
                sort: true,
                validator: (newValue, row, column) => {
                    if (newValue === "") {
                        return {
                            valid: false,
                            message: 'Value is required.'
                        };
                    }
                    return true;
                },
                style: (cell, row, rowIndex, colIndex) => {
                    return {
                        color: currentTheme.text
                    };
                },
                headerStyle: {
                    color: currentTheme.headerColor,
                    background: currentTheme.headerBackground
                }
            },
            {
                dataField: 'VariableDescription',
                text: 'Description',
                sort: true,
                validator: (newValue, row, column) => {
                    if (newValue === "") {
                        return {
                            valid: false,
                            message: 'Description is required.'
                        };
                    }
                    return true;
                },
                style: (cell, row, rowIndex, colIndex) => {
                    return {
                        color: currentTheme.text
                    };
                },
                headerStyle: {
                    color: currentTheme.headerColor,
                    background: currentTheme.headerBackground
                }
            },
            {
                dataField: 'df2',
                text: '',
                isDummyField: true,
                headerStyle: {
                    width: '70px',
                    background: currentTheme.headerBackground
                },
                formatter: (cellContent, row) => {
                    return (<div style={{ display: 'flex' }}>
                        <EditIcon style={{ color: currentTheme.secondary, cursor: 'pointer' }} onClick={() => { editSystemVariable(row); }} />
                    </div>
                    );
                }
            }
        ];

        return (
            <React.Fragment>
                <ThemeProvider theme={currentTheme}>
                    <CssBaseline />
                    <Backdrop className={classes.backdrop} id="systemVariableBackdrop" open={backDrop}>
                        <CircularProgress color="inherit" />
                    </Backdrop>
                    <Dialog zindex="100" fullScreen open={variableEditOpen} onClose={closeVariableEdit} TransitionComponent={Transition}>
                        <SystemVariableAdd parentCallback={closeVariableEdit}
                            refreshGrid={updateList}
                            model={recordToBeEdit}
                        />
                    </Dialog>
                    <Container maxWidth="xl" style={{ height: '95%' }} className={props.styles}>
                        <AppBar style={{ background: currentTheme.primary, color: currentTheme.color }}>
                            <Toolbar>
                                <Link to="/"><KeyboardBackspaceIcon /></Link>
                                <Grid container direction="row" alignItems="center">
                                    <Grid item>
                                        <Typography variant="h6" className={classes.title}>&nbsp;System Variables</Typography>
                                    </Grid>
                                    <Grid item>
                                        <StatusIcon />
                                    </Grid>
                                </Grid>
                                <Grid container justify="flex-end">
                                    <SmallMenu modified={false} />
                                </Grid>
                            </Toolbar>
                        </AppBar>
                        <Card color="primary" style={{ height: '100%', background: currentTheme.background }}>
                            <CardBody style={{ color: currentTheme.text, marginTop: "50px" }}>
                                <BootstrapTable bootstrap4 rowStyle={rowStyle} keyField='SystemVariableId' data={systemVariables} columns={columns}
                                    hover noDataIndication="No records found"/>
                            </CardBody>
                        </Card>
                    </Container>
                </ThemeProvider>
            </React.Fragment>
        );
    } 
    let content = fetchData();
    return (
        <>
            {content}
        </>
    );
}
